import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

class YouTubeComponent extends Component {

  render() {
    const opts = {
      height: '390',
      width: '640',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        modestbranding:1,
      }
    };
 
    return (
      <div>
        <div Style={"text-align:center;"} className="videoWrapper">
          <YouTube
            videoId={this.props.videoID}
            opts={opts}
            onReady={this._onReady}
          />
        </div>
      </div>
    );
  }
 
  _onReady(event) {
    // access to player in all event handlers via event.target
    //event.target.pauseVideo();
  }
}

export default YouTubeComponent;



// WEBPACK FOOTER //
// ./src/reusable_components/page_components/YouTubeComponent.jsx